<script setup>

import {defineComponent, ref} from 'vue'
import axios from "axios";
import {useRouter} from 'vue-router'

defineComponent({
  name: 'Contact'
})

const router = useRouter()
let messageErreur = ref(null);

let prenom = ref(null);
let nom = ref(null);
let ligne = ref(null);
let dateTime = ref(null);
let email = ref(null);
let telephone = ref(null);
let motif = ref(null);
let demande = ref(null);
const justificatifFile = ref(null);
const acceptPolitiqueConfidentialite = ref(false);
const motifList = ref(["Offre de transport", "Comportement agent", "Information voyageur", "Ponctualité", "Sécurité / sûreté", "Propreté", "PMR : signaler un obstacle", "Objet perdu / trouvé", "Autre"]);
const ligneList = ref(["Ligne 1 : Hagondange Gare Aragon <> Eurotransit Denis Papin", "Ligne 2 : Gare Maizières Parvis <> ZI du Malambas / Les Jonquières", "Ligne 3 : Gare Maizières Parvis <> Marques Avenue", "Ligne 4 : Gare Maizières Ouest <> Semécourt La Croix Blaise / Ecoparc"]);

//function de gestion
function validationFormulaire(e) {
  e.preventDefault();

  if(motif.value === null){
    messageErreur.value = "Le motif de votre demande doit être renseignée"
  } else {
    envoiMailContact()
  }
}

function envoiMailContact() {
  const formData = new FormData();
  formData.append('prenom', prenom.value);
  formData.append('nom', nom.value);
  formData.append('ligne', ligne.value);
  formData.append('dateTime', dateTime.value);
  formData.append('email', email.value);
  formData.append('telephone', telephone.value);
  formData.append('motif', motif.value);
  formData.append('demande', demande.value);
  formData.append('justificatifFile', justificatifFile.value);
  formData.append('acceptPolitiqueConfidentialite', acceptPolitiqueConfidentialite.value);

  console.log('Envoi mail contact')
  axios.post('contact/envoi', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(succes => {
      router.push({ name: 'SuccesContact' });
    },
    reason => {
      if( reason.response.status === 413 ) {
        messageErreur.value = "Fichiers trop volumineux (max 5Mo au total)";
      }
      else {
        messageErreur.value = "Erreur lors de l'envoi du formulaire de contact";
      }
    }
  )
}

function onChangeJustificatifFile(event) {
  const file = event.target.files[0];
  if (file && file.type !== 'application/pdf') {
    messageErreur.value = "Format incorrect. Veuillez télécharger un PDF";
    event.target.value = null;
  } else {
    messageErreur.value = "";
    justificatifFile.value = file;
  }
}

</script>

<template>
  <div class="home container overflow-auto">
    <h1>Contact</h1>
    <h2>Je souhaite obtenir des renseignements ou faire une réclamation</h2>
    <div>
      <div class="card">
        <div class="card-body">
          <div>
            <p>
              <u>Par courrier</u> à l’adresse Keolis 3 Frontières – 5 rue de l’Abbé Grégoire 57000 METZ
            </p>
            <p>
              <u>Par téléphone</u> au 03 87 34 60 00
            </p>
            <p>
              Les agents Keolis 3 Frontières vous répondent du lundi au vendredi de 8h à 12h et de 14h à 17h.
            </p>
            <p>
              <u>Par mail</u>, en remplissant le formulaire ci-dessous :
            </p>
            <p>
              <i>Pour toute demande ou réclamation, et afin que celle-ci soit traitée dans les meilleurs délais, veuillez préciser au maximum les circonstances et le motif de celle-ci (ex : numéro de la ligne empruntée, arrêt, direction, jour et heure...).<br>
                Les champs précédés de (*) sont obligatoires.</i>
            </p>
          </div>
        </div>
      </div>
    </div>

    <br>

    <form @submit="validationFormulaire">
      <div>
        <div class="card">
          <div class="card-body">
            <div>
              <div class="div_icon_input row">
                <div class="col-sm-12">
                  <select v-model="motif"
                          class="form-control"
                          id="inputMotif"
                          required>
                    <option disabled :value="null" selected>Motif*</option>
                    <option v-for="motifToSelect in motifList" :value="motifToSelect">
                      {{ motifToSelect }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="div_icon_input row ">
                <div class="col-sm-6">
                  <input v-model="prenom" id="inputPrenom" type="text" class="form-control" placeholder="Prénom*" required>
                </div>
                <div class="col-sm-6">
                  <input v-model="nom" id="inputNom" type="text" class="form-control" placeholder="Nom*" required>
                </div>
              </div>

              <div class="div_icon_input row">
                <div class="col-sm-12">
                  <select v-model="ligne"
                          class="form-control"
                          id="inputLigne">
                    <option disabled :value="null" selected>Ligne</option>
                    <option v-for="ligneToSelect in ligneList" :value="ligneToSelect">
                      {{ ligneToSelect }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="div_icon_input row">
                <div class="col-sm-12">
                  Date et heure
                  <input v-model="dateTime" id="inputDateTime" type="datetime-local" class="form-control">
                </div>
              </div>

              <div class="div_icon_input row">
                <div class="col-sm-6">
                  <input v-model="email" type="email" class="form-control" id="inputEmail"
                         placeholder="E-mail*" required>
                </div>
                <div class="col-sm-6">
                  <input v-model="telephone" type="tel" maxlength="12" class="form-control" id="inputTelephone"
                         placeholder="Téléphone*" required>
                </div>
              </div>

              <div class="div_icon_input row">
                <div class="col-sm-12">
                  Précisez l’incident de façon détaillée : contexte, horaire, ligne, arrêt, …
                  <textarea v-model="demande"
                          class="form-control"
                          id="inputDemande"
                          placeholder="Demande*" required></textarea>
                </div>
              </div>

              <div class="div_icon_input row">
                <div class="col-sm-12">
                  Pièce jointe<input class="form-control"
                                     @change="onChangeJustificatifFile"
                                     accept="application/pdf"
                                     id="inputJustificatifFile"
                                     type="file">
                </div>
              </div>

              <br>

              <p style="text-align: justify">
                Les informations recueillies par Riv’Connect, à partir de ce formulaire, font l’objet d’un traitement informatisé nécessaire à la gestion des relations commerciales et au suivi de votre demande. Ces données sont destinées à Riv’Connect, qui est responsable de traitement, ainsi que, le cas échéant à ses partenaires, sous-traitants ou prestataires situés dans ou hors de l’Union Européenne et aux filiales du Groupe Keolis. Vos données sont conservées pour la durée nécessaire au traitement de votre demande, à la gestion administrative et comptable des services souscrits et la promotion des services.<br>
                Pour plus d’informations, nous vous invitons à consulter notre <a class="lien" target="_blank" href="Politique-de-confidentialite-RivConnect.pdf">Politique de confidentialité</a>.<br>
                Conformément à la règlementation applicable, vous disposez d’un droit d’accès, de rectification et/ou de suppression de vos données personnelles. Vous pouvez également vous opposer à leur traitement à des fins commerciales. Vous pouvez exercer ces droits, ou adresser toute autre question aux coordonnées postales ou électroniques disponibles précédemment indiquées.<br>
              </p>

              <p> <input v-model="acceptPolitiqueConfidentialite" type="checkbox" id="inputAcceptPolitiqueConfidentialite" required> J’ai lu et compris la déclaration de confidentialité quant à la protection, le stockage et l’utilisation de mes données personnelles et donne mon consentement pour le traitement de toutes les données fournies dans mon dossier électronique dans le cadre de ma demande, y compris l’utilisation par des organisations externes.</p>

              <div v-if="messageErreur" style="color: red; text-align: center;">{{ messageErreur }}</div>

              <div class="text-center">
                <button type="submit" class="btn btn-vert">
                  <i class="fas fa-arrow-right"></i>
                  VALIDER
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <br>
</template>

<style scoped lang="scss">
@import "@/assets/main";

.lien{
  color: black;
  text-decoration: none;
}
.lien:hover{
  text-decoration: underline;
}

.card {
  border: none !important;

  .div_icon_input {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    @include icon_form;

    &:focus-within {
      i {
        color: var(--color-bleu-logo);
      }
    }
  }

}
</style>
